import styled from "styled-components"

export const Wrapper = styled("div")(() => ({
	width: "100%",
	maxWidth: "1220px",
	margin: "0 auto",
	height: "auto",
	padding: "20px 20px 40px",
}));

export const WrapperInner = styled("div")(({theme}) => ({
	display: "grid",
	gridTemplateColumns: "repeat(2, 1fr)",
	justifyContent: "center",

	[theme.down('sm')]: {
		gridTemplateColumns: "1fr",
	},
}));

export const Info = styled("div")(() => ({
	display: "flex",
	flexDirection: "column",
	gap: "20px",
	marginTop: "20px",
}));

export const Title = styled("h1")(() => ({
	// display: "block",
	textAlign: "center",
	fontSize: "25px",
	fontWeight: "bold",
}));

export const Subtitles = styled("h5")(() => ({
	fontSize: "17px",
	fontWeight: "bold",
	marginBottom: "10px",
}));

export const Content = styled("p")(({ theme }) => ({
	fontSize: "16px",
	fontWeight: "normal",
	lineHeight: "1.5",

	"& a": {
		color: theme.palette.primaryLight,
		textDecoration: "underline",
		textUnderlineOffset: "4px",
		transition: "all .3s ease-out",

		":hover": {
			color: `${theme.palette.primaryLight}90`,
		}
	},

	"& small": {
		fontSize: "13px",
		color: theme.palette.textMuted,
	},
}));

export const List = styled("ul")(() => ({
	listStylePosition: "inside",
	listStyleType: "disc",
}));

export const MapLocation = styled("div")(() => ({
	marginTop: "20px",
}));